import clsx from 'clsx'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const Modal = ({
  dataTestId,
  dismissClickOutsideModal = true,
  children,
  visible,
  close,
  addClass,
  variant = 'small',
}) => {
  const maxWidthClass = {
    small: 'max-w-[min(432px,100%)]',
    medium: 'max-w-[min(666px,100%)]',
    large: 'max-w-[min(900px,100%)]',
  }[variant]

  const modalWrapperClass = clsx(
    'DS__modal_box box-border m-6 max-phone:mx-4 max-phone:my-6',
    maxWidthClass
  )

  const handleClickOutside = e => {
    if (dismissClickOutsideModal) {
      close()
    } else {
      e.stopPropagation()
    }
  }

  return visible
    ? ReactDOM.createPortal(
        <div
          className={clsx('z-[5] fixed inset-0 overflow-y-auto bg-black/40', addClass)}
          data-testid={dataTestId}
        >
          <div
            className="flex justify-center items-center relative min-h-full"
            onClick={handleClickOutside}
          >
            <div className={modalWrapperClass} data-variant={variant}>
              <div onClick={e => e.stopPropagation()}>{children}</div>
            </div>
          </div>
        </div>,
        document.body
      )
    : null
}

Modal.propTypes = {
  dataTestId: PropTypes.string,
  dismissClickOutsideModal: PropTypes.bool,
  children: PropTypes.node,
  visible: PropTypes.bool,
  close: PropTypes.func,
  addClass: PropTypes.string,
  variant: PropTypes.oneOf(['small', 'medium', 'large']),
}

export default Modal
